module.exports = __webpack_public_path__ + "static/HF_FFSSC-f872f39e098dbc256cf32df91591408d.png";